<template>
	<div id='addUserCustoms'>
	    <!-- 内层dialog -->
		 <el-dialog
			:visible.sync="addVisible"
			:close-on-click-modal="false"
			width='696px'
			top='60px'
			:title="dialogTitle"
		>
		<div class='addContent'>
				<div class='addContent_container'>
					<el-form label-width='85px' label-position='left'>
						<el-form-item label="输入类型">
							 <el-select v-model="form.customType" placeholder="请选择" style='width: 100%;' size='small' @change='handTypeChange' :disabled='editDisabled'>
							    <el-option
							      v-for="item in options"
							      :key="item.customType"
							      :label="item.name"
							      :value="item.customType">
							    </el-option>
							  </el-select>
						</el-form-item>
						<el-form-item label='名称'>
							<el-row>
								<el-col :span='20'>
									<el-input v-model='form.columnName' placeholder='请输入名称' size='small'
										:disabled='superDisabled'
									></el-input>
								</el-col>
								<el-col :span='4' style='text-align:right;'>
									<el-checkbox v-model="form.isStuff" :disabled='superDisabled'>必填</el-checkbox>
								</el-col>
							</el-row>
						</el-form-item>

						<el-form-item label='取值类型' v-if='form.customType===3'>
							<el-radio v-model="form.valueType" label="0" :disabled='editDisabled'>手动输入</el-radio>
		 					<el-radio v-model="form.valueType" label="1" :disabled='editDisabled'>自动计算</el-radio>
		 					<transition name = "fade">
			 					<div class='autoCalculation' v-if='form.valueType =="1"'>
			 						<el-input v-model='form.formulaName' placeholder='请输入公式' style='width: 220px;' size='small' readonly @focus='shouqiAll=true'></el-input>
			 						<transition name = "fade">
				 						<div class="autoCalculation_card" v-show='shouqiAll' >
	  										<div class='rules'>
	  											<span v-for='item in rulesList' :key='item.id' class='rules_item'
	  												@click='handleRuleC(item)'
	  											>
	  												{{item.value}}
	  											</span>
	  										</div>
	  										<div class='numberList'>
	  											<span v-for='item in numberTypeList' :key='item.id' class='numberList_item' :style='{background:item.color}'
	  											@click='handleContentClick(item)'>
	  												{{item.name}}
	  											</span>
	  										</div>
	  										<div style='text-align: right;'>
												<el-button type='text' @click='shouqiAll=false'>收起</el-button>
												<el-button type='text' @click='deleteAll'>清空</el-button>
											</div>
										</div>
									</transition>

			 					</div>
		 					</transition>
						</el-form-item>
						<el-form-item label='取数规则' v-if='form.customType===3'>
							<el-checkbox v-model="form.decimalNum_s" :disabled='superDisabled'>取小数点后 <span v-if='form.decimalNum_s'>
								<el-input size='small' v-model='form.decimalNum' style='width: 50px;' ></el-input> 位
							</span> </el-checkbox>
						</el-form-item>
						<el-form-item label='单位' v-if='form.customType===3'>
							<el-input v-model='form.unit' placeholder='请输入单位' style='width: 100%;' size='small' :disabled='superDisabled'></el-input>
						</el-form-item>
						<el-form-item label='是否合计' v-if='form.customType===3'>
							<el-checkbox v-model="form.isTotal" :disabled='superDisabled'>是</el-checkbox>
						</el-form-item>
						<el-form-item label='下拉类型' v-if='form.customType=="4"'>
							<el-radio v-model="form.isChoice" label='0' :disabled='editDisabled'>单选</el-radio>
		 					<el-radio v-model="form.isChoice" label='1' :disabled='editDisabled'>多选</el-radio>
		 					<div class='selectRuleList'>
		 						<div class='s_title'>
		 							<span class='color_a'>选项列表</span>
		 							<el-checkbox v-model='form.colorFull' class='color_b'>以颜色区分</el-checkbox>
		 						</div>
		 						<div class='s_contentList' :style='selectStyle'>
		 							<el-scrollbar class="default-scrollbar">
		 								<draggable v-model='selectList' @start='handleStart' @end='handleEnd'>
			 								<transition-group name="list" tag="p">
			 									<div class='s_item' v-for='(item,index) in selectList' :key='item.optionName' >
					 								<div class='s_item_left'>
					 									<img src="/static/icon/drag_mark.svg" alt="" style="margin-left:5px;" class='s_draggable'>
					 									<span class='s_chose'
					 									:style='{background:item.color,color:item.color?"#fff":"",border:item.color?"":"1px solid #ddd"}'
					 									>
					 										{{item.optionName}}
					 									</span>
					 									<span class='clickFullColor' v-if='form.colorFull'>
					 										<el-color-picker
															  v-model="color"
															  show-alpha
															  @active-change='handleChaneg_c1($event,item)'
															  :predefine="predefineColors">
															</el-color-picker>
					 									</span>
					 								</div>
					 								<div class='s_item_right'>
					 									<span class='default' v-if='item.isDefault'  @click='item.isDefault=false'>默认</span>
					 									<span class='is_default' v-else @click='handleIsDefault(item)'>设为默认</span>
					 									<span class='edit' @click='handleEdit(item)'>编辑</span>
					 									<span class='delete' @click='handleDelete(item,index)'>删除</span>
					 								</div>
					 							</div>
			 								</transition-group>
			 							</draggable>
		 							</el-scrollbar>
		 						</div>
		 						<div class='batchAdd'>
		 							<el-button size='mini' class='batchAdd_btn' @click='handleBatchAddInputShow=true'>批量添加</el-button>
		 							<transition name = "fade">
			 							<el-card v-show='handleBatchAddInputShow' class='batchAddInput'>
			 								<el-input v-model="handleBatchAddInputVal" type='textarea'
			 								          placeholder="请将选项用 “换行” 隔开" :autosize="{minRows:6}">

			 								</el-input>
			 								<el-button size='mini' class='minButton' @click='handleBatchAdd'>添加</el-button>
			 							</el-card>
			 						</transition>
		 						</div>
		 					</div>
						</el-form-item>
						<el-form-item label='推送设置'>
							<el-row>
									<el-checkbox v-model="form.monitor" @change='handleMonitorChange'>监控该项</el-checkbox>
									<el-button type='text' size='small' style='margin-left: 30px;font-size: 14px;'
									@click='handleClickJumpSet'
												>还没有绑定微信账号？</el-button> 
							</el-row>
							<transition name = "fade">
								<div v-if="form.monitor&&(form.customType =='1'|| form.customType=='3' || form.customType=='4' || form.customType=='6')" style="display: block;margin-top: 10px;">
									<el-radio v-model="form.controlType" label="1">全部变动</el-radio>
				 					<el-radio v-model="form.controlType" label="2">按规则</el-radio>
				 					<transition name = "fade">
					 					<div class='numRange' v-if='form.controlType =="2"&& form.customType=="3"'>
					 						<span class='numSpan'>数值范围</span>
					 						<el-input size='small' v-model='form.numStart' style='width: 80px;' placeholder="开始"></el-input> -
					 						<el-input size='small' v-model='form.numEnd' style='width: 80px;' placeholder="结束"></el-input>
					 					</div>
				 					</transition>
				 					<transition name = "fade">
					 					<div class='numRange'  v-if='form.controlType =="2"&& form.customType=="1"'>
					 						<span class='numSpan'>包含关键字</span>
					 						<el-input size='small' v-model='form.textRule' style='width: 160px;' placeholder="关键字用','号隔开"></el-input>
					 					</div>
				 					</transition>
				 					<transition name = "fade">
					 					<div class='selectRule'  v-if='form.controlType =="2"&& form.customType=="4"'>
					 						<el-select v-model="form.selectList" multiple placeholder="以包含以下选项时" style='width: 230px;' size='small'
					 						collapse-tags>
											    <el-option
											      v-for="item in selectList"
											      :key="item.id"
											      :label="item.optionName"
											      :value="item.optionName">
											    </el-option>
										  </el-select>
					 					</div>
				 					</transition>
								</div>
							</transition>
						</el-form-item>
					</el-form>
				</div>
		</div>

			<div class='footer'>
				<el-button size='small' class='cancel_btn' @click="addVisible = false">取消</el-button>
				<el-button size='small' class='save_btn' @click='handleAddCustom'>保存</el-button>
			</div>
		</el-dialog>
		<!-- 内层dialog ===============over -->
	</div>
</template>
<script>
	import draggable from 'vuedraggable'
	export default {
		props:{
			showVisibles: Boolean,
			rowData: Object
		},
		components:{
			draggable
		},
		data(){
			return {
				superDisabled: false,     // 超级禁用
				selectStyle:{height:""},
				editDisabled: false,      // 是否禁用修改
				dialogTitle: "添加自定义项",
				shouqiAll: true,     // 自动计算是否收起
				allData:{},       // 公式验证
				superRules: false,      // 是否能点击计算规则
				numberTypeList:[],       // 自动计算公式所有数值类型
				rulesList:[           // 自动计算公式规则
					{value: "+",id:1},
					{value: "-",id:2},
					{value: "*",id:3},
					{value: "/",id:4},
					{value: "(",id:5},
					{value: ")",id:6},
				],
				inputShow_edit: true,     // 修改显示
				handleBatchAddInputVal: "",         // 批量添加类容
				handleBatchAddInputShow: false,  // 批量添加是否显示
				ismultiple: false,  // 是否多项
				color: "",// 当前颜色
				 predefineColors: [
		          '#ff4500',
		          '#ff8c00',
		          '#ffd700',
		          '#90ee90',
		          '#00ced1',
		          '#1e90ff',
		          '#c71585',
		          'rgba(255, 69, 0, 0.68)',
		          'rgb(255, 120, 0)',
		          'hsv(51, 100, 98)',
		          'hsva(120, 40, 94, 0.5)',
		          'hsl(181, 100%, 37%)',
		          'hsla(209, 100%, 56%, 0.73)',
		          '#c7158577'
		        ],
			   selectList:[],
			   options: [],
		        form:{
		        	textRule:"",// 文本框规则
		        	formulaName: "",
				 	decimalNum_s:false,
		        	 colorFull: false,   // 颜色区分
		        	customType: 4,//自定义列类型
		        	columnName:"",   //自定义列名字
		        	isStuff:false,   //是否必填
		        	monitor: false,
		        	isControl:"0",   // 是否监控
		        	controlType: "1",  // 是否全部监控是1不是2
		        	rule:'',          // 规则
		        	customId:'',         // 固定选项id1234
		        	numStart: "",
		        	numEnd: "",
		        	valueType:"0",  // 数值自定义取值类型 手动=0 自动=1
		        	formula:"",    //自动取值公式
		        	decimalNum: "",  //数值类型 保留小数
		        	unit: "",  //单位
		        	isTotal: false,  // 数值类型 是否合计 是=1 否=0
		        	optionList:[],
		        	isChoice: '0',    // 多选还是单选 单=0 多=1
		        	id:"",
		        	selectList:[]
		        }
			}
		},
		created() {
			this.getCustomType();
		},
		mounted() {

		},
		updated(){
		},
		computed: {
			// 显示弹窗
			addVisible: {
				get () {
					return this.showVisibles;
				},
				set (val) {
					this.$emit('update:showVisibles', val);
				}
			},
		},
		methods: {
			handleMonitorChange(val) {
				if(val) {
					this.form.controlType = "1";
				}
			},
			handleClickJumpSet() {
				this.addVisible = false;
				this.$emit('closeModel', true);

			},
			// 计算内容点击
			handleContentClick(i) {
				// if(this.superRules) {
				// 	return;
				// }
				// this.superRules=true;
			    this.form.formulaName += "{"+i.name+"}";
			    if(i.id==='3' ){
			     this.form.formula += "this.allData.debitMoney";
			    }else if( i.id === '4'){
			     this.form.formula += "this.allData.creditorMoney";
			    }else{
			     this.form.formula += "this.allData.field_"+i.id;
			    }

		   },
			// 清空
			deleteAll() {
				this.form.formulaName = '';
				this.form.formula= '';
			},
			// 计算规则点击
			handleRuleC(i) {
				// if(!this.superRules) {
				// 	return;
				// }
				// this.superRules=false;
				this.form.formulaName += i.value;
				this.form.formula += i.value;
			},
			// 获取所有数值类型
			getAllNuberType() {
				this.$http.post('custom/findNumTypeCoustom' , {}).then(res=>{
					if(res&&res.data.code==1) {
						this.numberTypeList = res.data.data.map(i=>{
							i.color=this.randomColor();
							return i;
						});
					}
				})
			},
			// 编辑下拉 列表
			handleEdit(row) {
				if(!row.id) {
					this.$prompt('请输入修改名称', '', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          inputPattern: /\S/,
			          inputValue: row.optionName,
			          closeOnClickModal:false,
			          inputErrorMessage: '名称不能为空！'
			        }).then(({ value }) => {
			        	row.optionName = value;
			        }).catch(() => {

			        });
			        return;
				}
				this.$http.post('custom/deleteCustomAndOption' , {id:row.id, type: "0"}).then(res=>{
					if(res && res.data.code==1) {
						if(res.data.data) {
							this.$confirm('当前修改会将历史记录该项更新，是否继续修改并更新？', '提示', {
						          confirmButtonText: '确定',
						          cancelButtonText: '取消',
						          type: 'warning'
						        }).then(() => {
						          	 this.$prompt('请输入修改名称', '', {
								          confirmButtonText: '确定',
								          cancelButtonText: '取消',
								          inputPattern: /\S/,
								          inputValue: row.optionName,
								          closeOnClickModal:false,
								          inputErrorMessage: '名称不能为空！'
								        }).then(({ value }) => {
								        	this.$http.post('custom/updateOption' , {id:row.id, optionName: value}).then(res=>{
								        		if(res&&res.data.code==1) {
								        			this.$message.success(res.data.msg);
								        			this.$emit('handleSuccess',"1");
								        			row.optionName = value
								        		}
								        	})
								        }).catch(() => {

								        });
						        }).catch(() => {

						        });
						}else {
							this.$prompt('请输入修改名称', '', {
					          confirmButtonText: '确定',
					          cancelButtonText: '取消',
					          inputPattern: /\S/,
					          closeOnClickModal:false,
					          inputValue: row.optionName,
					          inputErrorMessage: '名称不能为空！'
					        }).then(({ value }) => {
					        	this.$http.post('custom/updateOption' , {id:row.id, optionName: value}).then(res=>{
					        		if(res&&res.data.code==1) {
					        			this.$message.success(res.data.msg);
					        			//this.$emit('handleSuccess',"1");
					        			row.optionName = value
					        		}
					        	})
					        }).catch(() => {

					        });
						}
					}
				})
			},

			// 设为默认
			handleIsDefault(row) {
				if(this.form.isChoice === "0") {
					this.selectList.forEach(i=>{
						i.isDefault = false;
					})
					row.isDefault = true;
				}else {
					row.isDefault = true;
				}
			},
			// 添加/修改自定义项
			handleAddCustom() {
				if(this.form.customType===3&&this.form.valueType==="1") {
					if(!this.form.formula) {
						return this.$message.warning("检测到自动计算公式为空！")
					}else {
						try {
							let super_data = this.form.formulaName.replace(/(\{)(.*?)(\})/g,2.2);
							let o = eval(super_data)
						}catch(e) {
							return this.$message.warning("检测到自动计算公式不合法！")
						}
					}
				}
				if(!this.form.decimalNum_s) {

					this.form.decimalNum = "";
				}

                this.form.isControl = this.form.monitor?"1":"0";
                if(this.form.customType==1) {
                	this.form.rule = this.form.textRule;
                }else if(this.form.customType==2) {
                	this.form.rule = "";
                }else if(this.form.customType==3) {
                	if(this.form.numStart==="") {
                		this.form.numStart=null
                	}
                	if(this.form.numEnd==="") {
                		this.form.numEnd=null
                	}
                	if((this.form.numEnd===null&&this.form.numStart===null) || isNaN(this.form.numEnd) || isNaN(this.form.numStart)) {
                		if(this.form.monitor&&this.form.controlType==="2") {
		                	return this.$message.warning('规则为空或不合法！')
		                }

                	}
                	this.form.rule = this.form.numStart+"-"+this.form.numEnd;
                }else if(this.form.customType==4) {
                	if(this.form.selectList.length) {
						this.form.rule = this.form.selectList.toString();
					}
                }
                if(this.form.monitor&&this.form.controlType==="2"&&!this.form.rule) {
                	this.$message.warning('请输入规则！')
                }
				this.form.optionList = this.selectList;
				let formData = JSON.parse(JSON.stringify(this.form));
				formData.isStuff=formData.isStuff?1:0;
				formData.isTotal=formData.isTotal?1:0;
				formData.colorFull=formData.colorFull?1:0;
				formData.decimalNum_s=formData.decimalNum_s?1:0;
				formData.isChoice=formData.isChoice==="0"?0:1;
				if(formData.optionList.length) {
					formData.optionList.forEach(i=>{
						i.isDefault = i.isDefault?1:0;
					});
				}

				this.$http.post('custom/saveCustomColumn' , formData).then(res=>{
					if(res&&res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.addVisible = false;
						this.$emit('handleSuccess',"0");
					}
				})
			},
			// 获取自定义类型下拉框
			getCustomType() {
				this.$http.post('custom/getCustomColumnTitle' , {}).then(res=>{
					if(res&&res.data.code == 1) {
						this.options = res.data.data;
					}
				})
			},
			// 删除下拉选项
			handleDelete(row,index) {
				if(row.id) {
					this.$http.post('custom/deleteCustomAndOption' , {id:row.id, type: "0"}).then(res=>{
						if(res&&res.data.code == 1) {
							if(res.data.data) {
								this.$confirm('删除后历史数据中有关该项也会被清除，是否删除？', '提示', {
						          confirmButtonText: '确定',
						          cancelButtonText: '取消',
						          type: 'warning'
						        }).then(() => {
						        	this.selectList.splice(index,1);

						        }).catch(() => {

						        });
							}else {
								this.selectList.splice(index,1);
							}
						}
					})
				}else {
					this.selectList.splice(index,1);
				}

			},
			// 批量添加下拉框
			handleBatchAdd() {
				let data = this.handleBatchAddInputVal.split(/[(\r\n)\r\n]+/);
				data = [...new Set(data)]
				if(this.selectList.length) {
					if(data.length) {
						this.selectList.forEach(i=>{
							data.forEach((k,index)=>{
								if(k=== i.optionName) {
									data.splice(index,1);
								}
							})
						})
					}

				}
				data.forEach((i,index)=>{
        			if(i) {
    					this.selectList.push({
				   			optionName: i,
				   			color: this.form.colorFull?this.randomColor():"",
				   			isDefault:false
				   		})
        			}

        		})

        		this.handleBatchAddInputShow = false;
			},
			// 拖动开始
			handleStart(e){
				e.item.style.background='#eee';
				e.item.style.transform='translateX(20px)';
				e.item.style.borderRadius ='5px';
				e.item.style.opacity ='.5';
			},
			// 拖动结束
			handleEnd(e) {
				e.item.style.background='';
				e.item.style.transform='translateX(0px)';
				e.item.style.borderRadius ='0px';
				e.item.style.opacity ='1';
			},
			// 类型切换清空form
			handTypeChange(val) {
				this.form = Object.assign(this.form , {
					formulaName: "",
					decimalNum_s: false,
					colorFull: false,   // 颜色区分
					customType: val?val:1,//自定义列类型
		        	columnName:"",   //自定义列名字
		        	isStuff:false,   //是否必填
		        	monitor: false,
		        	controlType: "1",
		        	numStart: "",
		        	numEnd: "",
		        	valueType:"0",  // 数值自定义取值类型 手动=0 自动=1
		        	formula:"",    //自动取值公式
		        	decimalNum: "",  //数值类型 保留小数
		        	unit: "",  //单位
		        	isTotal: false,  // 数值类型 是否合计 是=1 否=0
		        	optionList:[],
		        	isChoice: '0',    // 多选还是单选 单=0 多=1
		        	id:"",
		        	selectList:[],
		        	isControl:"0",   // 是否监控
		        	controlType: "1",  // 是否全部监控是1不是2
		        	rule:'',          // 规则
		        	customId:'',         // 固定选项id1234
				})

				this.superDisabled = false;
			},
			// 随机颜色函数
			randomColor(){
				let r,g,b,a;
				r = Math.floor(Math.random()*256);
				g = Math.floor(Math.random()*256);
				b = Math.floor(Math.random()*256);
				a = 0.8;
				return 'rgba(' + r +',' + g + ',' + b + ',' + a +")";
			},
			handleChaneg_c1(val,row){
				row.color = val;
			},
			// 获取监控数据
			async getMonitorData(ids,type) {
				try {

					if(ids==="1" || ids==="2" || ids==="3" || ids==="4") {
						this.superDisabled = true;
						let res = await this.$http.post('custom/getfixed' , {num:ids});
						if(res&&res.data.code==1) {
							let datas = res.data.data;
							this.rowData.isControl = datas.isControl;
							this.rowData.controlType = datas.controlType;
							this.rowData.rule = datas.rule;

						}

					}else {
						this.superDisabled =false
					}

					let isBlooane=this.rowData.isControl==="1"?true:false;
					this.$set(this.form,'monitor',isBlooane)
					this.form.controlType=this.rowData.controlType;
					if(!this.form.monitor || this.form.controlType==1) {
						return
					}
					// 推送赋值
					 if(this.rowData.customType==1) {
		                	this.form.textRule = this.rowData.rule;
		                }else if(this.rowData.customType==2) {

		                }else if(this.rowData.customType==3) {
		                	let rule = this.rowData.rule.split('-');


		                	this.form.numStart = rule[0]==="null"?"":rule[0];
		                	this.form.numEnd = rule[1]==="null"?"":rule[1];

		                }else if(this.rowData.customType==4) {
		                	this.form.selectList = this.rowData.rule.split(',');
		                }
				// 赋值结束
				}catch(e) {
					console.log(e)
				}

			}
		},
		watch:{
			'form.colorFull'(val) {
				if(val) {
					if(this.selectList.length) {
						this.selectList.forEach(i=>{
							i.color = this.randomColor();
						})
					}
				}else {
					if(this.selectList.length) {
						this.selectList.forEach(i=>{
							i.color = "";
						})
					}
				}
			},
			showVisibles(val) {
				this.getAllNuberType();
				if(val) {
					this.handleBatchAddInputVal= "";        // 批量添加类容
					this.handleBatchAddInputShow= false;  // 批量添加是否显示
					if(this.rowData.id) {
						this.editDisabled = true;
						this.dialogTitle='修改自定义项'
						this.form = Object.assign(this.form , {
							decimalNum_s: this.rowData.decimalNum_s?true:false,
							colorFull: this.rowData.colorFull?true:false,   // 颜色区分
							customType: Number(this.rowData.customType),//自定义列类型
				        	columnName:this.rowData.columnName,   //自定义列名字
				        	isStuff:this.rowData.isStuff?true:false,   //是否必填
				        	monitor: false,
				        	controlType: "1",
				        	numStart: "",
				        	numEnd: "",
				        	valueType:this.rowData.valueType+"",  // 数值自定义取值类型 手动=0 自动=1
				        	formulaName: this.rowData.formulaName,
				        	formula:this.rowData.formula,    //自动取值公式
				        	decimalNum: this.rowData.decimalNum,  //数值类型 保留小数
				        	unit: this.rowData.unit,  //单位
				        	isTotal: this.rowData.isTotal?true:false,  // 数值类型 是否合计 是=1 否=0
				        	optionList:this.rowData.optionList,
				        	isChoice:this.rowData.isChoice+"",    // 多选还是单选 单=0 多=1
				        	id:this.rowData.id,
				        	selectList:[],
				        	customId:this.rowData.id,
						})


						this.getMonitorData(this.rowData.id,this.rowData.customType);

						this.$set(this,'selectList',this.rowData.optionList)
					}else {
						this.handTypeChange();
					}
				}else {
					this.selectList = [];
					this.dialogTitle='添加自定义项';
					this.editDisabled = false;

				}
			},
			'form.isChoice'(val){
				if(!this.rowData.id) {
					this.selectList = [];
				}
				this.ismultiple = !this.ismultiple;
				this.form.monitor = false;
				if(this.rowData.id) {
					this.form.monitor=this.rowData.isControl==="1"?true:false;
				}
			},
			"selectList":{
				handler(val) {
					if(val.length<=0){
						this.selectStyle.height = "0px"
					}else if(val.length===1) {
						this.selectStyle.height = "50px"
					}else if(val.length===2) {
						this.selectStyle.height = "90px"
					}else if(val.length===3) {
						this.selectStyle.height = "130px"
					}else if(val.length===4) {
						this.selectStyle.height = "170px"
					}else{
						this.selectStyle.height = "220px"
					}
				}
			}


		}
	}
</script>
<style lang="less">
	.transform-origin {
		top:220px;
	}
	#addUserCustoms {
		 .fade-enter,.fade-leave-to {
            opacity: 0;
            transform: translateY(-30px);
        }
        .fade-enter-active ,.fade-leave-active {
            transition: all .1s linear;
        }


		.el-dialog {
			.el-dialog__header {
				padding: 40px 30px 0;
				text-align:left;
				border-bottom: none;
			}
			.el-dialog__body {
				padding: 30px 36px 40px 24px;
			}
		}
		.numRange {
			display: inline-block;
			.numSpan {
				margin-right: 5px;
			}
		}
		.selectRule {
			display: inline-block;
		}
		.selectRuleList {
			border: 1px solid #ddd;
			.s_title {
				padding: 0 15px;
				display: flex;
				justify-content: space-between;
				.color_a {
					color: #9B9B9B;
					font-size: 12px;
				}
				.color_b {
					color: #666;
					.el-checkbox__label {
						font-size: 12px;
					}
					.el-checkbox__input {
						width: 12px;
						height: 14px;
					}
				}
			}
			.s_contentList {
				.default-scrollbar {
					width: 100%;
					height: 100%;
				}
				.el-scrollbar__wrap,.default-scrollbar__wrap {
				  overflow-x: hidden;
				}
				.s_item {
					padding: 0 15px;
					display: flex;
					justify-content: space-between;
					font-size: 12px;
					margin-bottom: 3px;
					.s_item_right {
						color:#4A4A4A;
						.edit {
							margin: 0 10px 0 10px;
							cursor: pointer;
							&:hover{
								opacity:.8;
							}
						}
						.delete {
							color: #DB374B;
							cursor: pointer;
							&:hover{
								opacity:.8;
							}
						}
						.is_default {
							display:none;
							cursor: pointer;
							&:hover{
								opacity:.8;
							}
						}
						.default {
							color: #409EFF;
						}
					}
					&:hover{
						.is_default{
							display: inline-block;
						}
					};
					.s_item_left {
						display: flex;
						align-items: center;
						.s_draggable {
							cursor: move;
						}
						.s_chose {
							padding: 0 15px;
							margin: 0 13px 0 20px;
							height: 28px;
							border-radius: 4px;
							line-height: 28px;

						}
						.clickFullColor {
							width: 16px;
							height: 16px;
							display: inline-block;
							border-radius: 50%;
							cursor: pointer;
							background: linear-gradient(to bottom , #AB7171 , #F5A623 , #7ED321 , #20BD90);
							position: relative;
							.el-color-picker {
								width: 16px;
								height: 16px;
								position: absolute;
								opacity:0;
								.el-color-picker__trigger {
									width: 16px;
									height: 16px;
									border: none;
									padding: 0;
								}
							}
						}
					}
				}
			}
			.batchAdd {
				padding: 17px 0 22px 15px;
				position: relative;
				.batchAdd_btn {
					width: 68px;
					text-align:center;
					background: #E9E9E9;
					color: #666;
					padding: 7px 0;
				}
				.batchAddInput {
					position: absolute;
					width: 300px;
					z-index: 99;
					text-align:right;
				}
			}
		}
		.autoCalculation {
			display: inline-block;
			position: relative;
			user-select: none;
			.autoCalculation_card {
				position: absolute;
				right: 0;
				background: #eee;
				width: 206px;
				border: 2px solid #ddd;
				z-index: 9999;
				padding: 10px 5px 0px;
				.rules {
					line-height: 25px;
					display: flex;
					justify-content: space-between;
					.rules_item {
						cursor: pointer;
						display: inline-block;
						width: 25px;
						height: 25px;
						text-align:center;
						border-radius: 2px;
						background-color: #333;
						margin-right:5px;
						color: #fff;
						&:active{
							transform:scale(1.1);
						};
					}
				}
				.numberList {
					line-height: 20px;
					margin-top: 10px;
					.numberList_item{
						display: inline-block;
						padding: 5px 10px;
						margin: 0 5px 5px 0;
						color: #fff;
						border-radius: 5px;
						cursor: pointer;
						&:active{
							transform:scale(1.1);
						};
					}
				}
			}
		}
		.footer {
			text-align: center;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/dialog/addUserCustom.vue